import { merge } from '../helpers/strict-type-checks';
import { IPaneView } from '../views/pane/ipane-view';
import { Coordinate } from './coordinate';
import { PriceLineOptions } from './price-line-options';
import { Series } from './series';
import { SimpleLineOptions } from './simple-line-options';
import { CustomSimpleLinePaneView } from '../views/pane/custom-simple-line-pane-view';
import { TimePointIndex } from './time-data';
import { Nominal } from 'lightweight-charts';

export class CustomSimpleLine {
	private readonly _series: Series;
	private readonly _priceLineView: CustomSimpleLinePaneView;
	private readonly _options: SimpleLineOptions;
	//private readonly _index1: number;//TimePointIndex;
	//private readonly _index2: number;// TimePointIndex;

	public constructor(series: Series, options: SimpleLineOptions) {
		this._series = series;
		this._options = options;
		this._priceLineView = new CustomSimpleLinePaneView(series, this);

		const timeScale = series.model().timeScale();
		const off = 352086.9384;
		const allV = 1592892126.249 + off;
        //const fir = series.firstValue().timePoint;// as number;

		//let xTime1 = (this._options.data[0].time as number-1592892126.249-off)/10000.0;
		//let xTime2 = (this._options.data[1].time as number-1592892126.249-off)/10000.0;
		//let xx = timeScale.coordinateToNumber(xTime1 as Coordinate);
		//this._index1 = xTime1;//timeScale.coordinateToNumber(xTime1 as Coordinate);//timeScale.coordinateToIndex(xTime as Coordinate);// this._options.data.time as number as Coordinate);
		//this._index2 = xTime2;//timeScale.coordinateToNumber(xTime2 as Coordinate);// this._options.data.time as number as Coordinate);
//		this._index2 = timeScale.coordinateToIndex(xTime2 as Coordinate);// this._options.data.time as number as Coordinate);
//		this._index = timeScale.coordinateToIndex(1590.616552966 as Coordinate);// this._options.data.time as number as Coordinate);
	}

	public applyOptions(options: Partial<PriceLineOptions>): void {
		merge(this._options, options);
		this.update();
		this._series.model().lightUpdate();
	}

	public options(): SimpleLineOptions {
		return this._options;
	}

	public paneView(): IPaneView {
		return this._priceLineView;
	}

	public update(): void {
		this._priceLineView.update();
	}

	public yCoord(): Coordinate | null {

		const series = this._series;
		const priceScale = series.priceScale();
		const timeScale = series.model().timeScale();

		//if (this._options.extended!==ExtendedType.ExtendedInfinity)
		//{
			return priceScale.priceToCoordinate(this._options.data[0].value,0.0);
		//}
		return this._options.data[0].value as Coordinate;

		if (timeScale.isEmpty() || priceScale.isEmpty()) {
			return null;
		}

		const firstValue = series.firstValue();
		if (firstValue === null) {
			return null;
		}

		return priceScale.priceToCoordinate(this._options.data[0].value, firstValue.value);
	}

	public yCoord2(): Coordinate | null {

		const series = this._series;
		const priceScale = series.priceScale();
		const timeScale = series.model().timeScale();

		//return this._options.data[1].value as Coordinate;
		//if (this._options.extended!==ExtendedType.ExtendedInfinity)
		//{
		return priceScale.priceToCoordinate(this._options.data[1].value,0.0);
		//}

		if (timeScale.isEmpty() || priceScale.isEmpty()) {
			return null;
		}

		const firstValue = series.firstValue();
		if (firstValue === null) {
			return null;
		}

		return priceScale.priceToCoordinate(this._options.data[1].value, firstValue.value);
	}	


	private getX(time:number) : number {
		const series = this._series;
		//const priceScale = series.priceScale();
		const timeScale = series.model().timeScale();
		const offs =     391500.0;
		let allV = 1592892126.249 + offs;
		//allV 1593244213.1874
		//const fir = series.firstValue().timePoint;// as number;
		//if (series.firstValue()!=null)
		
		//let dd = series.firstValue();
		//..let bi = timeScale.baseIndex();
		//..let gg3 = timeScale.indexToCoordinate(bi);
		//..let bs = timeScale.barSpacing();

		/*
		time: 0
		UTC time: 1592892126.249
		time: 160
		UTC time: 1594388666.629
		*/

		let ts = 1593064879.937;//1592892126.249;
		         
		let te = 1594388666.629;
		let is = 19.0;
		let ie = 160.0;
		let del = te-ts;
		let steps = ie-is;
		let step = del/steps;
			
		
//		let xTime1 = (time-allV)/(10000.0);
	    let point = (time-ts)/(step);
		let xTime1 = is+ Math.floor(point);
		return xTime1;
	}

	public xCoord1(): Coordinate | null {

		const series = this._series;
		//const priceScale = series.priceScale();
		const timeScale = series.model().timeScale();


		let i1 = this.getX(this._options.data[0].time as number);

		let i35 = this.getX(1593169616.522 as number); //result 35
		let i160 = this.getX(1594388666.629 as number); //result 160
		
		let y = i35+i160;
		

		return timeScale.indexToCoordinate(i1 as TimePointIndex);
//		return timeScale.numberToCoordinate(i1);
		//let i1 = timeScale.coordinateToNumber(this._options.data[0].time as number);
		//series.nearestIndex(this._options.data[0].time as Index);
		
		//series.nearestIndex(Math.floor(this._options.data[0].time as number) as TimePointIndex);
	
		//let t1     = this._options.data[0].time as number;
		//let xTime1 = t1/1000000.0;
		//let index1 = timeScale.coordinateToIndex(xTime1 as Coordinate);// this._options.data.time as number as Coordinate);
		
		//return timeScale.numberToCoordinate(index1);// - timeScale.indexToCoordinate(0);
		
			//return priceScale.priceToCoordinate(this._options.data.value,0.0);
		//}

		//return 0.0 as Coordinate;

/*
		if (timeScale.isEmpty() || priceScale.isEmpty()) {
			return null;
		}

		const firstValue = series.firstValue();
		if (firstValue === null) {
			return null;
		}

		return priceScale.priceToCoordinate(this._options.price, firstValue.value);
		*/
	}	

	public xCoord2(): Coordinate | null {

		const series = this._series;
		//const priceScale = series.priceScale();
		const timeScale = series.model().timeScale();

		//if (this._options.extended!==ExtendedType.ExtendedInfinity)
		//{			
			//let t2     = this._options.data[1].time as number;
			//let xTime2 = t2/1000000.0;
			//let index2 = timeScale.coordinateToIndex(xTime2 as Coordinate );// this._options.data.time as number as Coordinate);

			let i2 = this.getX(this._options.data[1].time as number);
			return timeScale.indexToCoordinate(i2 as TimePointIndex);
			//return timeScale.numberToCoordinate(i2);
	
//			return timeScale.numberToCoordinate(index2);
			//return timeScale.numberToCoordinate(this._index2);// - timeScale.indexToCoordinate(0);

			//return timeScale.numberToCoordinate(this._index2);
			//return timeScale.indexToCoordinate(this._index2);
			//return priceScale.priceToCoordinate(this._options.data.value,0.0);
		//}

		//return 0.0 as Coordinate;
	}	

}
